// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fb","advertDetailHeaderPrice__value":"c-m_fc","advertDetailHeaderPrice__label":"c-m_fe"};